import { createSelector } from 'reselect'
import { RootState } from 'core/store'

function getNetwork(state: RootState) {
  return state.network
}

export const isCommunicating = createSelector(getNetwork, state => 0 < state.network)
